/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionLeadStatus
 */
export interface PalAuthSubmissionLeadStatus {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    is_default?: boolean;
    /**
     * 
     */
    color?: string;
    /**
     * 
     */
    background_color?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionLeadStatus interface.
 */
export function instanceOfPalAuthSubmissionLeadStatus(value: object): value is PalAuthSubmissionLeadStatus {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PalAuthSubmissionLeadStatusFromJSON(json: any): PalAuthSubmissionLeadStatus {
    return PalAuthSubmissionLeadStatusFromJSONTyped(json, false);
}

export function PalAuthSubmissionLeadStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionLeadStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'is_default': json['is_default'] == null ? undefined : json['is_default'],
        'color': json['color'] == null ? undefined : json['color'],
        'background_color': json['background_color'] == null ? undefined : json['background_color'],
    };
}

export function PalAuthSubmissionLeadStatusToJSON(json: any): PalAuthSubmissionLeadStatus {
    return PalAuthSubmissionLeadStatusToJSONTyped(json, false);
}

export function PalAuthSubmissionLeadStatusToJSONTyped(value?: PalAuthSubmissionLeadStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'is_default': value['is_default'],
        'color': value['color'],
        'background_color': value['background_color'],
    };
}

